import { render, staticRenderFns } from "./TemplateTableComponent.vue?vue&type=template&id=710cd061&"
import script from "./TemplateTableComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports